import React from "react";
// import { Link } from "react-router-dom";
// import "./Card.css";
import { useState } from "react";
function Card(props) {
    const [imgState, setimgState] = useState(props.img);
    return (
        <div className="w-100 justify-center text-center">

            <img onMouseEnter={() => {
                setimgState(props.imgUrl2);
            }}
                onMouseLeave={() => {
                    setimgState(props.img);
                }}
                src={imgState} 
                className="w-100"
                alt="" />
            <div className="w-100 ">
                <h4 className="fs-6 pt-3  uppercase">{props.title}</h4>
                <p className="">Shop Now</p>
                {/* <Link to="#" className="card_link">Shop Now</Link> */}
            </div>
        </div>

    );
}

export default Card;